import { nl } from "../../../../date-fns/locale/nl.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    nl
  }
};